import DetailSection from '../ui/DetailSection';
import styles from './InfoContent.module.css';

export function InfoProse({ children }) {
  return <div className={`${styles.prose} text-krit-surface`}>{children}</div>;
}

export function InfoSection({ id, title, children }) {
  return <DetailSection id={id} title={title} variant="paper">
    <InfoProse>{children}</InfoProse>
  </DetailSection>;
}

export default function InfoArticle({ children }) {
  return <article className="min-w-0 rounded-xl bg-krit-paper p-5 sm:p-8">
    <InfoProse>{children}</InfoProse>
  </article>;
}
